import React from "react";
import BrandLogo from "../components/BrandLogo";
import InvitationMessage from "../components/invitation/InvitationMessage";
import InvitationBody from "../components/invitation/personalmessage";
import OptionsPanel from "components/panels/OptionsPanel";
import { DownloadInvoiceButton } from "./DownloadInvoiceButton";

interface Props {
  brand: server.dto.BrandSmall
  invitationBody: string
  message: string
  downloadFileUrl: string
}

const BrandInfoPanel = (props: Props) => {

  return <OptionsPanel>
    <div className="content-section flex-column gap-big">

      <BrandLogo brand={props.brand} boxWhenNoImage />

      <div>
        <InvitationMessage
          message={props.message}
          brandName={props.brand.name}
        />
      </div>

      {props.invitationBody != null && <div>
        <InvitationBody
          message={props.invitationBody}
        />
      </div>}

      <DownloadInvoiceButton downloadFileUrl={props.downloadFileUrl} />
    </div>
  </OptionsPanel>;
};

export default BrandInfoPanel;